<template>
  <div class="text-gray-dark">
    <SectionTitle v-model="show">
      Amenities
    </SectionTitle>

    <div v-if="show">
      <div class="flex justify-between text-gray-dark">
        <div v-for="(column, idx) in columns" :key="idx" class="w-1/2 first:mr-4 md:w-1/3">
          <div v-for="amenity in column" :key="amenity.name" class="mb-3">
            <svg
              class="mr-1 inline-block"
              width="17"
              height="12"
              viewBox="0 0 17 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.8044 1.28992L6.68111 11.5L0 5.5L1.18093 4.0986L6.56791 9.03214L15.5 0L16.8044 1.28992Z" fill="#4348DB" />
            </svg>
            <NuxtLink v-if="amenity.href" :to="amenity.href" class="underline">
              {{ amenity.name }}
            </NuxtLink>
            <span v-else>{{ amenity.name }}</span>
          </div>
        </div>
      </div>
      <a
        v-if="venue.amenities.length > limitAmenities && !showAll"
        href="#"
        class="letter-sp15 link mt-6 inline-block font-medium uppercase underline"
        @click.prevent="showAll = true"
      >
        Show All Amenities
      </a>
    </div>
  </div>
</template>

<script>
import SectionTitle from '~/components/venue/SectionTitle'

export default {
  components: { SectionTitle },

  props: {
    venue: { type: Object, required: true },
  },

  data: () => ({
    show: true,
    showAll: false,
  }),

  computed: {
    limitAmenities () {
      return this.$screen.name === 'sm' ? 6 : 9
    },

    amenitiesToShow () {
      if (! this.showAll) {
        return this.venue.amenities.slice(0, this.limitAmenities)
      }

      return this.venue.amenities
    },

    cols () {
      return this.$screen.name === 'sm' ? 2 : 3
    },

    columns () {
      let i; let j
      const temparray = []
      const chunk = Math.ceil(this.amenitiesToShow.length / this.cols)
      for (i = 0, j = this.amenitiesToShow.length; i < j; i += chunk) {
        temparray.push(this.amenitiesToShow.slice(i, i + chunk))
      }

      return temparray
    },

  },
}
</script>
